import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MB_DIALOG_DATA, MbDialogBody, MbDialogHeader, MbAlertModule } from '@am/moebius';
import { IRoom } from '@core/models/modals';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-modal-room',
  standalone: true,
  imports: [CommonModule, MbDialogBody, MbDialogHeader, MbAlertModule, SharedModule],
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss'],
})
export class ModalRoomComponent extends DialogWrapperComponent implements OnInit {
  public error: boolean;
  public roomName: string;

  constructor(@Inject(MB_DIALOG_DATA) public dialogData: IRoom) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.error = !this.dialogData.room;
    this.roomName = this.dialogData.room.name;
  }
}
